'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Select = require('./Select');

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Select2["default"];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/_bee-select@1.0.16@bee-select/build/index.js
// module id = 97
// module chunks = 0